import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';

const el = document.getElementById('react-component-g4-logistics-portal-expense-approval');
if (el) {
  let keywords = ['zzz', 'zzzz'];
  if (el.dataset && el.dataset.keywords) {
    try {
      const parsed = JSON.parse(el.dataset.keywords);
      if (Array.isArray(parsed) && parsed.length > 0) {
        keywords = parsed;
      }
    } catch (e) {
      // Fallback to default
    }
  } else if (window.expenseApprovalKeywords && Array.isArray(window.expenseApprovalKeywords)) {
    keywords = window.expenseApprovalKeywords;
  }

  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/expense-approval"
    infiniteScroll={true}
    message_if_none = 'No jobs waiting for expense approval.'
    expenseApprovalScreen={true}
    separatorKeywords={keywords}
  />,
  el);
}
